import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useSidebar } from "../../context/sidebar/sidebar.context";

const SideMenuLink = ({
  pathTo,
  text,
  icon,
  handleClick,
  currentLink,
  subLinks,
  isMobileMenuOpen = false,
}) => {
  const { isCollapsed } = useSidebar();
  const location = useLocation();

  const isActiveLink = (path) => {
    return (
      location.pathname.substring(1).split("/")[0] ===
        path.substring(1).split("/")[0] && path
    );
  };

  // Determine if we should show collapsed view (only when collapsed AND not on mobile)
  const shouldShowCollapsed = isCollapsed && !isMobileMenuOpen;

  return (
    <div
      className={`text-plumb tracking-normal overflow-hidden transition-all duration-200 ease-in-out rounded-lg p-4 m-2 w-full flex flex-row justify-start relative ${
        isActiveLink(pathTo)
          ? "bg-whiteLilac rounded-lg"
          : "opacity-40"
      } ${shouldShowCollapsed ? 'justify-center' : ''}`}
      style={{
        maxHeight: isActiveLink(pathTo) && !shouldShowCollapsed ? "200px" : "56px",
      }}
      title={shouldShowCollapsed ? text : ""}
    >
      {shouldShowCollapsed ? (
        // When collapsed, make the entire container clickable
        <Link
          onClick={handleClick}
          to={pathTo}
          className="flex items-center justify-center w-full h-full group"
        >
          <img
            src={icon}
            alt="side menu icon"
            height="27"
            width="27"
            className="self-center"
          />
          {/* Custom tooltip for collapsed state */}
          <div className="absolute left-full ml-2 px-2 py-1 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50 pointer-events-none">
            {text}
            {/* Tooltip arrow */}
            <div className="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-1 w-0 h-0 border-r-4 border-r-gray-900 border-t-2 border-t-transparent border-b-2 border-b-transparent"></div>
          </div>
        </Link>
      ) : (
        // When expanded, show normal layout
        <>
          <img
            src={icon}
            alt="side menu icon"
            height="27"
            width="27"
            className="self-start"
          />
          <div>
            <Link
              onClick={handleClick}
              to={pathTo}
              className={`text-base font-bold text-left w-full ml-8 pr-4`}
            >
              {text}
            </Link>
            {subLinks &&
              subLinks.map((subLink, index) => (
                <div key={index} className={`text-left ml-8 mt-5`}>
                  <Link
                    to={subLink.pathTo}
                    className={`font-bold text-base ${
                      location.pathname !== subLink.pathTo
                        ? "opacity-50"
                        : "opacity-100"
                    }`}
                  >
                    {subLink.text}
                  </Link>{" "}
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SideMenuLink;
